import React, { useState, useEffect, useContext } from 'react';

import { Modal, Form, Row, Col, Input, Button, Select, ColorPicker, Upload, Space, message } from 'antd';
import { CloseOutlined, SaveOutlined, ArrowLeftOutlined, ArrowRightOutlined, PlusOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { ModalContext } from '../../../../shared/context/ModalContext';

import product from '../../../../shared/data/product.json';
import brand from '../../../../shared/data/brand.json';
import Loading from '../../../../shared/components/Loading/Index';
import global from '../../../../shared/utility/global';

export default function ModalForm(props) {
    const modal = useContext(ModalContext);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [files, setFiles] = useState([]);
    const [uid, setUid] = useState('');
    const [display, setDisplay] = useState('block');

    useEffect(() => {
        onLoad();
    }, [props.open]);

    const onLoad = async () => {
        if (!props.open)
            return;

        setLoading(true);

        if (props.id > 0) {
            var findObject = product.find(m => m.id === props.id);
            form.setFieldsValue(findObject);
        }

        setLoading(false);
    };

    const onCancel = () => {
        form.resetFields();
        props.onCancel();
    };

    const onSave = async () => {
        var validations = await form.validateFields().then(() => true).catch(() => false);
        if (!validations) {
            message.warning('Por favor completa los datos del formulario.', 7);
            return;
        }

        modal.confirm('¿Esta seguro de realizar la acción?', async () => {
            onCancel();
        });
    };

    const onNext = () => {
        var lastIndex = files.length - 1;
        for (let index = 0; index < files.length; index++) {
            if (files[index].uid === uid && index < lastIndex) {
                setUid(files[index + 1].uid);
                break;
            }

            if (files[index].uid === uid && index === lastIndex) {
                setUid(files[0].uid);
                break;
            }
        }
    }

    const onPrev = () => {
        var lastIndex = files.length - 1;
        for (let index = 0; index < files.length; index++) {
            if (files[index].uid === uid && index > 0) {
                setUid(files[index - 1].uid);
                break;
            }

            if (files[index].uid === uid && index === 0) {
                setUid(files[lastIndex].uid);
                break;
            }
        }
    }

    const handleCancel = () => setPreviewOpen(false);

    const handlePreview = async () => {
        var file = files.find(m => m.uid === uid);
        if (file !== undefined) {
            setPreviewImage(file.url || file.preview);
            setPreviewOpen(true);
            setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
        }
    };

    // const handleChange = ({ fileList: newFileList }) => {
    //     setFileList(newFileList);
    //     return true;
    // };


    // const beforeUpload = (file) => {
    //     setFileList([...fileList, file]);
    //     return false;
    // }

    const onRemove = () => {
        var file = files.find(m => m.uid === uid);
        if (file !== undefined) {
            const index = files.indexOf(file);
            const newFiles = files.slice();
            newFiles.splice(index, 1);
            newFiles.forEach((item, index) => {
                item.index = index + 1;
            });
            setFiles(newFiles);
        }
    }

    // const onChange = ({ fileList: newFileList }) => {
    //     setFileList(newFileList);
    // };

    // const onCustomRequest = async (info) => {
    //     // global.getBase64(info.file, (imageUrl) => { info.onSuccess(imageUrl); });
    //     var imageUrl = await global.getBase64(info.file);
    //     info.onSuccess(imageUrl);
    // };

    const onBefore = async (file) => {
        file.url = await global.getBase64(file);
        file.index = files.length + 1;
        if (files.length === 0)
            setUid(file.uid);

        setFiles(collection => { return [...collection, file]; });
        return false;
    };

    return (
        <Modal
            title={`${(props.id === 0 ? 'Nuevo' : 'Modificar')} Producto`}
            open={props.open}
            destroyOnClose={true}
            className='product-page'
            onCancel={(prop) => {
                if (!prop.target.className.toString().match("ant-modal-wrap") || prop.type === "keydown")
                    onCancel();
            }}
            width={600}
            footer={[
                <Button key="1" onClick={onCancel} shape='round'>
                    <CloseOutlined /> Cancelar
                </Button>,
                <Button key="2" onClick={onSave} type={'primary'} shape='round'>
                    <SaveOutlined /> Guardar
                </Button>
            ]}
        >
            <Loading visible={loading} text="cargando">
                <Form
                    form={form}
                    layout="vertical"
                >
                    <Row gutter={20} className='mt-20'>
                        <Col span={24}>
                            <div>
                                <Button onClick={onPrev} className='prev' type='text' icon={<ArrowLeftOutlined />} />
                                <Button onClick={onNext} className='next' type='text' icon={<ArrowRightOutlined />} />
                                <div className='image-content' style={{ display: display }}>
                                    <div className='image-item'>
                                        <div className="vertical-center">
                                            <img src={files.find(m => m.uid === uid)?.url} />
                                        </div>
                                    </div>
                                </div>
                                <div className='image-total'>
                                    {
                                        files.find(m => m.uid === uid)?.index === undefined ? null :
                                            files.find(m => m.uid === uid)?.index + " / " + files.length
                                    }
                                </div>
                                <div className='image-options'>
                                    <Space wrap>
                                        <Upload
                                            showUploadList={false}
                                            multiple={true}
                                            beforeUpload={onBefore}
                                        >
                                            <Button icon={<PlusOutlined />} />
                                        </Upload>
                                        <Button icon={<EyeOutlined />} onClick={handlePreview} />
                                        <Button icon={<DeleteOutlined />} danger type="primary" onClick={onRemove} />
                                    </Space>
                                </div>
                            </div>
                        </Col>

                        <Col span={24} className='mt-10'>
                            <Form.Item
                                label="Nombre"
                                name="name"
                                rules={[{ required: true, message: 'Campo obligatorio.' }]}
                            >
                                <Input
                                    placeholder="Ingrese nombre"
                                    autoComplete="off"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="Marca"
                                name="brandId"
                                rules={[{ required: true, message: 'Campo obligatorio.' }]}
                            >
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    placeholder="Seleccione"
                                >
                                    {brand.map(item => (
                                        <Select.Option
                                            key={item.id}
                                            value={item.id}
                                        >
                                            {item.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Precio"
                                name="price"
                                rules={[{ required: true, message: 'Campo obligatorio.' }]}
                            >
                                <Input
                                    placeholder="0.00"
                                    autoComplete="off"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Color"
                                name="color"
                                rules={[{ required: true, message: 'Campo obligatorio.' }]}
                            >
                                <ColorPicker showText />
                            </Form.Item>
                        </Col>


                    </Row>
                </Form>
                <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                </Modal>
            </Loading>
        </Modal>
    );
}